<template>
  <div>
    <clouded-glass class="device">
      <div slot="content">
        <div :class="deviceInfo.status===0 ? 'status' : 'status alarm'" class="status"></div>
        <div class="main">
          <span class="name">{{ deviceInfo.name }}</span>
          <el-image
            v-if="deviceInfo.iconTopological"
            :src="$ftpUrl + deviceInfo.iconTopological"
            class="logo"
            fit="fill"
            style="width: 26px; height: 22px"></el-image>
          <div class="line cross-line"></div>
          <div class="type">类型: <span class="text-white">{{ deviceInfo.typeCnName }}</span></div>
          <div v-if="deviceShowBrand" class="brand">品牌: <span class="text-white">{{ deviceInfo.brandCnName }}</span>
          </div>
          <div v-if="deviceShowModel" class="model">型号: <span class="text-white">{{ deviceInfo.modelCnName }}</span>
          </div>
          <div class="note">备注: <span class="text-white"
                                      style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{
              deviceInfo.note ? deviceInfo.note : '--'
            }}</span></div>
          <div style="margin: 15px 0;"></div>
          <div v-if="!deviceShowBrand" class="brand"></div>
          <div v-if="!deviceShowModel" class="model"></div>
          <div class="line cross-line"></div>
          <div class="control">
            <div>
              <div @touchstart="() => showDialog('查看功能','ShowControlList',false,'40vw','control')" @click="() => showDialog('查看功能','ShowControlList',false,'40vw','control')"
                   class="button text-lightBlue">
                查看功能
              </div>
              <div @touchstart="() => showDialog('查看测点','ShowList',false,'40vw','point')" @click="() => showDialog('查看测点','ShowList',false,'40vw','point')" class="button text-lightBlue">
                查看测点
              </div>
            </div>
            <div>
              <div @touchstart="() => showThresholdDialog('告警阈值','ThresholdValueList',false,'90vw','point')"  @click="() => showThresholdDialog('告警阈值','ThresholdValueList',false,'90vw','point')"
                   class="button text-blue">
                告警阈值
              </div>
              <div @touchstart="() => showDialog('修改空间','BelongsModify',true,'40vw','belongs')" @click="() => showDialog('修改空间','BelongsModify',true,'40vw','belongs')" class="button text-blue">
                修改空间
              </div>
            </div>
            <div>
              <div @touchstart="() => showDialog('编辑设备','Modify',true,'40vw','device')"  @click="() => showDialog('编辑设备','Modify',true,'40vw','device')" class="button text-blue">编辑设备</div>
              <div @touchstart="() => showDialog('可视化编辑','VisualEdit',true,'50vw','visual')" @click="() => showDialog('可视化编辑','VisualEdit',true,'50vw','visual')" class="button text-blue">可视化编辑
              </div>
            </div>
            <div>
              <div @touchstart="deleteDevice(deviceInfo)" @click="deleteDevice(deviceInfo)" class="button text-danger">解除绑定</div>
            </div>
          </div>
        </div>
      </div>
    </clouded-glass>

    <function-dialog-component
      :dialog-title="dialogTitle"
      :dialogVisible.sync="dialogVisible"
      :width="width"

      @dialogClose="(data) => this.dialogVisible = data">
      <div slot="content" style="min-height: 40vh;">
        <component :is="component" ref="functionDialogComponent" :deviceInfo="deviceInfo" :dialogData="dialogData"
                   :form="form"
                   :spaceInfoId="spaceInfoId" :spaceValue="spaceValue" @receiveData="receive"></component>
      </div>
      <div class="dialog-footer" slot="footer" style="text-align: center;margin-bottom: 15px;" v-if="showFooter">
        <el-button @touchstart="() => {this.dialogVisible = false}" @click="() => {this.dialogVisible = false}" size="mini">关 闭</el-button>
        <el-button @touchstart="saveData" @click="saveData" type="primary" size="mini">保 存</el-button>
      </div>
    </function-dialog-component>
    <!--      告警阈值-->
    <dialog-component
      :dialog-title="dialogTitle"
      :dialogVisible.sync="thresholdDialogVisible"
      :width="width"
      @dialogClose="(data) => this.thresholdDialogVisible = data"
      @dialogShow="()=>{this.$refs.thresholdComp.listByDeviceId()}">
      <div slot="content" :style="{width:diaWidth,height:diaHeight}" style="min-height: 40vh;">
        <threshold-value-list ref="thresholdComp" :deviceInfo="deviceInfo" :form="form"></threshold-value-list>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import ModifyDevice from "./Modify";
import ThresholdValueList from "./ThresholdValueList.vue";
import DialogHeader from "@/components/device_details/comp/DialogHeader";
import DialogComponent from "@/components/DialogComponent";
import CloudedGlass from "@/components/style/CloudedGlass";
import {deleteDevice, modifyDevice} from '@/network/device-info';
export default {
  name: "DeviceShowComp",
  components: {CloudedGlass, DialogHeader, ModifyDevice, FunctionDialogComponent, ThresholdValueList, DialogComponent},
  data() {
    return {
      thresholdDialogVisible: false,
      dialogVisible: false,
      form: {},
      dialogTitle: '',
      diaWidth: "",
      diaHeight: "80vh",
      component: 'VisualEdit',
      dialogData: null,
      receiveData: null,
      showFooter: false,
      width: '80vw',
    }
  },
  props: {
    deviceInfo: {},
    spaceInfoId: {},
    spaceValue: {},
    deviceShowBrand: {
      type: Boolean,
      default: () => true
    },
    deviceShowModel: {
      type: Boolean,
      default: () => true
    }
  },
  methods: {
    showThresholdDialog(dialogTitle, componentName, showFooter, width, distinguish) {
      this.dialogTitle = dialogTitle;
      this.showFooter = showFooter;
      this.width = width;
      this.dialogData = distinguish;
      this.thresholdDialogVisible = true;
    },
    showDialog(dialogTitle, componentName, showFooter, width, distinguish) {
      this.dialogTitle = dialogTitle;
      this.showFooter = showFooter;
      this.width = width;
      this.dialogData = distinguish;
      this.component = () => import('@/views/basic_operations/device_management/device_manager/comp/' + componentName + '.vue');
      this.dialogVisible = true;
    },
    receive(data) {
      this.receiveData = data;
    },
    saveData() {
      if ( this.dialogData === 'visual' ) {
        this.deviceInfo.visualId = this.receiveData;
      } else if ( this.dialogData === 'device' ) {
        if ( !this.$stringIsNotNullAndEmpty(this.receiveData.name) ) {
          this.$message.error('请先填写设备名称');
          return;
        }
        this.deviceInfo.name = this.receiveData.name;
        this.deviceInfo.note = this.receiveData.note;
      } else if ( this.dialogData === 'belongs' ) {
        if ( this.receiveData == null || !this.receiveData.spaceId ) {
          this.$message.error('请选择变更的空间');
          return;
        }
      }
      this.modifyDevice();
    },
    modifyDevice() {
      modifyDevice(this.deviceInfo).then(res => {
        if ( res.code === 0 ) {
          this.$message.success('操作成功');
        } else {
          this.$message.error('操作失败');
        }
        this.dialogVisible = false;
        this.$emit('getDeviceList');
      })
    },

    deleteDevice(val) {
      const h = this.$createElement;
      this.$confirm("提示", {
        title: '提示',
        message: h('div', {class: 'tips'}, [
          h('div', '是否确认解除绑定设备：' + val.name),
          h('div', {class: 'information'}, '*解除绑定只影响通过空间维护和查看设备，不影响设备的历史数据和实时告警。')
        ]),
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        callback: action => {
          if ( action === 'confirm' ) {
            deleteDevice(val.id).then(res => {
              if ( res.code === 0 ) {
                this.$message.success('删除成功');
                this.$emit('getDeviceList');
              } else {
                this.$message.error('删除失败');
              }
            });
          }
        }
      })
    }
  },
  watch: {
    dialogVisible() {
      if ( !this.dialogVisible ) {
        this.$refs.functionDialogComponent.$destroy()
      }
    },
    thresholdDialogVisible() {
      if ( !this.thresholdDialogVisible ) {
        this.$refs.thresholdComp.$destroy()
      }
    }
  }
}

import FunctionDialogComponent from "@/components/FunctionDialogComponent";
</script>

<style scoped>
.device {
  margin: 10px 10px 10px 5px;
  width: 240px;
  height: 338px;
  background: rgba(0, 0, 0, 0);
}

.status {
  width: 20px;
  height: 2px;
  background: #07E6F8;
  opacity: 1;
}

.status.alarm {
  background: #de3200;
}

.main {
  width: 178px;
  overflow: auto;
  margin: 30px 46px 10px 31px;
}

.name {
  width: 60px;
  height: 20px;
  font-size: 1.06rem;
  font-weight: bold;
  line-height: 20px;
  color: #299BFF;
  opacity: 1;
}

.logo {
  float: right;
}

.cross-line {
  width: 100%;
  margin: 10px 0 16px 0;
  /*border: 1px solid #299BFF;*/
  border-bottom: 1px solid rgba(41, 155, 255, 0.2);
  opacity: 0.5;
}

.type, .brand, .model, .note {
  height: 22px;
  font-weight: 400;
  line-height: 19px;
  color: #89A0B8;
  opacity: 1;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.control div:not(.button) {
  display: flex;
}

.control .button {
  width: 100%;
  text-align: center;
  line-height: 24px;
  margin: 3px;
  height: 24px;
  background: rgba(41, 155, 255, 0.2);
  border-radius: 2px;
  font-size: 0.85rem;
}

.control .button:hover {
  background: rgba(41, 155, 255, 0.5);
  cursor: pointer;
}

.tips {

}

.information {
  font-size: 0.8rem;
  color: yellow;
  margin-top: 15px;
}

</style>
